import httpClient from './httpClient';

// API Service für Customers (Admin-Panel intern)
export const customersApi = {
  getList: async () => {
    const response = await httpClient('/admin/customers');
    return response;
  },

  getOne: async (id) => {
    const response = await httpClient(`/admin/customers/${id}`);
    return response;
  },

  create: async (data) => {
    const response = await httpClient('/admin/customers', {
      method: 'POST',
      body: JSON.stringify(data),
    });
    return response;
  },

  update: async (id, data) => {
    const response = await httpClient(`/admin/customers/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
    return response;
  },

  delete: async (id) => {
    await httpClient(`/admin/customers/${id}`, {
      method: 'DELETE',
    });
    return { id };
  },
};

// API Service für External API Keys
export const externalKeysApi = {
  getList: async () => {
    const response = await httpClient('/admin/api-keys');
    return response;
  },

  create: async (data) => {
    const response = await httpClient('/admin/api-keys', {
      method: 'POST',
      body: JSON.stringify(data),
    });
    return response;
  },

  delete: async (id) => {
    await httpClient(`/admin/api-keys/${id}`, {
      method: 'DELETE',
    });
    return { id };
  },
};

// Auth API
export const authApi = {
  login: async (username, password) => {
    const response = await httpClient('/api/auth/login', {
      method: 'POST',
      body: JSON.stringify({ username, password }),
    });
    return response;
  },
};

export default { customersApi, externalKeysApi, authApi };
